module.exports = require('./dist/migrations');
